import img1 from '../../../assets/images/comm-1.jpg'
import img2 from '../../../assets/images/comm-2.jpg'
import img3 from '../../../assets/images/comm-3.jpg'
import img4 from '../../../assets/images/comm-4.jpg'

const commImgs = [
    {
        image: img1,
        title: "MAKE A PLAN EPISODE 6: JERMO"
    },
    {
        image: img2,
        title: "FEMALE EMOPWEREMENT: NEW EPISODE"
    },
    {
        image: img3,
        title: "PODCAST STUDIO SETUP 101"
    },
    {
        image: img4,
        title: "NIKE SHOWROOM 90"
    },
]

export default commImgs